import { render } from "./ViewCollectorHistory.vue?vue&type=template&id=68b75dbc&scoped=true"
import script from "./ViewCollectorHistory.vue?vue&type=script&lang=js"
export * from "./ViewCollectorHistory.vue?vue&type=script&lang=js"

import "./ViewCollectorHistory.vue?vue&type=style&index=0&id=68b75dbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b75dbc"]])

export default __exports__